import Oauth2LstApi from 'Apis/Oauth2LstApi';
import { vi } from 'date-fns/locale';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
 import { fetchAdPayload, getKstTimestamp, useGtm } from 'hooks/useGtm';
import { isMobile } from 'react-device-detect';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import ApiResultModal from 'Components/ApiResultModal';
import MbpAthnTknCrtRqstApi from 'Apis/MbpAthnTknCrtRqstApi';
const { v4: uuidv4 } = require("uuid");
declare global {
    interface Window { AppSsoRespFunc: any; }
}
declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
    }
}
const AppSsoLoginUi = ({ referrer, viewType, onClose, gameSvcCd, mltSetYn }: { referrer?: string | null, viewType: string, onClose?: () => void, gameSvcCd?: string| null, mltSetYn?: string }) => {
        const openMbpAthnWindow = async (athnPrpsCd:string = "MTHD_CHNG_APP", loginId:string|null = null) => {
        try {
            const tokenResp = await MbpAthnTknCrtRqstApi(athnPrpsCd, loginId);
            if(tokenResp.apiHdr.code !== "ATHN0000") {
                alert(`${tokenResp.apiHdr.msg}`);
                return;
            }

            const reqKMCISForm = document.createElement("form");
            reqKMCISForm.method = "post";
            reqKMCISForm.action = "https://www.kmcert.com/kmcis/web/kmcisReq.jsp";
            reqKMCISForm.style.display = "none";

            const trCertInput = document.createElement("input");
            trCertInput.type = "hidden";
            trCertInput.name = "tr_cert";
            trCertInput.value = tokenResp.apiBody.kmcTkn;

            const trUrlInput = document.createElement("input");
            trUrlInput.type = "hidden";
            trUrlInput.name = "tr_url";
            trUrlInput.value = `${process.env.REACT_APP_KMC_REDIRECT_URL}`;

            const trVerInput = document.createElement("input");
            trVerInput.type = "hidden";
            trVerInput.name = "tr_ver";
            trVerInput.value = "V2";

            reqKMCISForm.appendChild(trCertInput);
            reqKMCISForm.appendChild(trUrlInput);
            reqKMCISForm.appendChild(trVerInput);
            document.body.appendChild(reqKMCISForm);

            const isMacDesktop = !isMobile && /Mac/i.test(navigator.platform || navigator.userAgent);

            if(isMobile === true || isMacDesktop) {
                reqKMCISForm.target = "";
            }else {
                const KMCIS_window = window.open('', 'KMCISWindow', 'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250' );
                if(KMCIS_window == null){
                    // alert(" ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.");
                    document.body.removeChild(reqKMCISForm);
                    return;
                }
                reqKMCISForm.target = "KMCISWindow";
            }

            reqKMCISForm.submit();
            document.body.removeChild(reqKMCISForm);
        }catch(error:any) {
            alert(error?.message || "본인인증 요청 중 오류가 발생했습니다.");
        }
    }
    const { push: gtmPush } = useGtm();
    const navigate = useNavigate();
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (800/2));
    // providers from API
    const [providers, setProviders] = useState<Array<any>>([]);

    // Reserved scheme logic (kept for quick rollback / re-enable).
    const ua = navigator.userAgent || '';
    const isIos = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isMacFamily = /Macintosh|Mac OS X|MacIntel/i.test(ua) || /Mac/i.test(navigator.platform || '') || isIos;
    const scheme = isMacFamily ? 'safari://open?url=' : 'samsunginternet://open?url=';

    const openWithSchemeFallback = (targetUrl: string) => {
        const encodedUrl = encodeURIComponent(targetUrl);
        const primaryUrl = `${scheme}${encodedUrl}`;
        const fallbackUrl = `intent://open?url=${encodedUrl}`;
        let pageHidden = false;
        let launcherFrame: HTMLIFrameElement | null = null;

        const onVisibilityChange = () => {
            if (document.hidden) {
                pageHidden = true;
            }
        };

        document.addEventListener('visibilitychange', onVisibilityChange);
        launcherFrame = document.createElement('iframe');
        launcherFrame.style.display = 'none';
        launcherFrame.src = primaryUrl;
        document.body.appendChild(launcherFrame);

        window.setTimeout(() => {
            document.removeEventListener('visibilitychange', onVisibilityChange);
            if (launcherFrame && launcherFrame.parentNode) {
                launcherFrame.parentNode.removeChild(launcherFrame);
            }
            if (!pageHidden) {
                window.location.href = fallbackUrl;
            }
        }, 1200);
    };

    const reservedSchemeLogic = { ua, isIos, isMacFamily, scheme, openWithSchemeFallback };
    void reservedSchemeLogic;

    const SsoLoginFunc = (e:any)=>{
        if (isMobile) {
            // Intentionally not using scheme flow for now.
            window.location.href = e;
        } else {
            window.open(e, "_blank", "width=600,height=800 left=" + popupX + "top=" + popupY);
        }
    }
    const buildFullReferrer = (r?: string | null) => {
        if (!r) return '';
        try {
            const decoded = decodeURIComponent(r);
            // already absolute URL
            if (/^https?:\/\//i.test(decoded)) return decoded;
            // protocol-relative
            if (/^\/\//.test(decoded)) return window.location.protocol + decoded;
            // path-only -> prepend origin
            if (decoded.startsWith('/')) return window.location.origin + decoded;
            // otherwise treat as relative path
            return window.location.origin + '/' + decoded;
        } catch (e) {
            return '';
        }
    };

    const redirectByReferrer = (target: string) => {
        if (!target) {
            navigate("/", { replace: true });
            return;
        }

        if (/^https?:\/\//i.test(target)) {
            try {
                const targetUrl = new URL(target);
                if (targetUrl.origin === window.location.origin) {
                    navigate(`${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`, { replace: true });
                } else {
                    window.location.replace(target);
                }
                return;
            } catch (e) {
                window.location.replace(target);
                return;
            }
        }

        navigate(target, { replace: true });
    };

    useEffect(() =>{
        Oauth2LstApi().then((resp)=> {
            try {
                const list = resp && resp.apiBody && resp.apiBody.oauth2Lst ? resp.apiBody.oauth2Lst : [];
                setProviders(list);
                console.log('oauth2 list', list);
            } catch (err) {
                console.error('AppOauth2LstApi parse error', err);
            }
        }).catch(err => {
            console.error('AppOauth2LstApi error', err);
        });
        const AppSsoRespFunc = async (code:string) => {
            switch (code) {
                case"ATHN0000":
                const tsKst = getKstTimestamp();
                const adPayload = await fetchAdPayload( 'BBO');
                 if (window.fbq) {
                        window.fbq('trackCustom', 'BBO_FB_Login_Complete');
                    }
                    try {
                        gtmPush('BBO_GA_Login_Complete', {
                            gameSvcCd,
                            ts: tsKst,
                            ...adPayload,
                        });
                    } catch (gtmErr) {
                        if (typeof window !== 'undefined') {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'BBO_GA_Login_Complete',
                                gameSvcCd,
                                ts: tsKst,
                                ...adPayload,
                            });
                        }
                    }
                console.log(viewType);
                        // 리퍼러가 있으면 해당 페이지로, 없으면 홈으로 이동
                        if (viewType === "modal") {
                            if (typeof onClose === 'function') {
                                try { onClose(); } catch (e) { console.error('onClose threw', e); }
                            }
                        }else{
                            if (referrer) {
                                const target = buildFullReferrer(referrer);
                                redirectByReferrer(target);
                            } else {
                                IsMntnInqApi("BBO").then((resp) => {
                                    if (resp.apiHdr.code === "GAME0000" && resp.apiBody.isMntn === "Y") {
                                    //    ApiResultModal.open("점검 중입니다. 잠시 후 다시 시도해주세요."); 
                                    } else {
                                        navigate(`/Connect/AppStrt`, { replace: true });
                                    }
                                });
                            }
                        }
                break;
                case"ATHN2002":
                    navigate("/Connect/BlckMemb",{replace:true});   
                break;
                case"ATHN2005":
                    navigate("/Connect/membLvdCncl",{replace:true});
                break; 
                case"ATHN2007":

                        navigate(`/Connect/OtpAthn?referrer=${encodeURIComponent(`/Connect/AppStrt`)}`);

                break;
                case"ATHN2003":
                    navigate("/DrmcMemb",{replace:true});
                break;  
                case "ATHN2008":
                    openMbpAthnWindow("MTHD_CHNG_APP");
                break;      
                case"ATHN2009":
                    if (referrer) {
                        navigate(`/Connect/MembJoin?referrer=${encodeURIComponent(referrer)}`, { state: { joinTypeCd: "SSO" }, replace: true });
                    } else {
                        navigate(`/Connect/MembJoin`, { state: { joinTypeCd: "SSO" }, replace: true });
                    }
                break;
            }
        }
        window.AppSsoRespFunc = AppSsoRespFunc;
    },[referrer]);

    const resolveImg = (src: string | undefined) => {
        if (!src) return '';
        if (/^https?:\/\//.test(src)) return src;
        // assume public path
        return process.env.PUBLIC_URL + (src.startsWith('/') ? src : '/' + src);
    }

    return (
        <>
        <div className='ssoLoginWrap'>
            {providers && providers.length > 0 ? (
                providers.map((p: any) => {
                    if (String(p?.provider || '').toUpperCase() === 'APPLE' && !isMacFamily) {
                        return null;
                    }

                    return (
                        <button key={p.provider} className={`colNoneBtn ${'btn' + p.provider}`} onClick={() => {
                            const full = buildFullReferrer(referrer);
                            const url = `${p.mgpApiUrl}&appYn=Y`;
                            SsoLoginFunc(url);
                        }}>
                            <img src={process.env.PUBLIC_URL + `/images/Connect/Login/${p.provider}Btn.png`} alt={p.provider} />
                        </button>
                    );
                })
            ) : (
                // fallback: show nothing or placeholder
                null
            )}
        </div>
        </>
    )
}

export default AppSsoLoginUi;
